/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const AuthenticationOauth2MicrosoftGet = {
  id: 'authentication.oauth2.microsoft.get',
  tag: 'Authentication',
  summary: 'Login using Microsoft over OAuth2',
  description: '',
  method: 'get',
  route: () => `/authentication/oauth2/microsoft`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
